function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  points: "0,7.7 2,7.7 2,3.4 5.5,6.7 6.9,5.3 3.5,2 7.7,2 7.7,0 0,0  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "6.9,18 5.5,16.6 2,19.9 2,15.6 0,15.6 0,23.3 7.7,23.3 7.7,21.3 3.5,21.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "15.6,0 15.6,2 19.8,2 16.4,5.3 17.8,6.7 21.3,3.4 21.3,7.7 23.3,7.7 23.3,0  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "21.3,19.9 17.8,16.6 16.4,18 19.8,21.3 15.6,21.3 15.6,23.3 23.3,23.3 23.3,15.6 21.3,15.6  "
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.1,15.1h7v-7h-7V15.1z M10.1,10.1h3v3h-3V10.1z"
}));

var SvgPhotoCenter = function SvgPhotoCenter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.3 23.3",
    style: {
      enableBackground: "new 0 0 23.3 23.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhotoCenter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/photo-center.1c93325c.svg";
export { ForwardRef as ReactComponent };